import React, { useState } from "react";
import { Button } from '@mui/material';
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import Loop from "@mui/icons-material/Loop";
 
const ImageSlider = (props) => {
    
    const [nbrSlide, setNbrSlide] = useState(0);
    const photoArr = props.photoArr;
    const photoArrLength = photoArr.length;
    const theme = useTheme();
    const [newIndex, setActiveStep] = React.useState(0);
    const [buttonName, setButtonName] = useState("Next");
    const [buttonIcon, setButtonIcon] = useState("ltr");
          
    const goToNextPicture = () => {
      if (nbrSlide !== 0){
        //  do nothing - this is being done just to fix the warning msg (nbrSlide not used) 
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (newIndex === (photoArrLength - 2)){
          theme.direction="rtl";
          setButtonIcon("rtl");
          setButtonName("Restart");
      }else{
          theme.direction="ltr";
          setButtonIcon("ltr");
          setButtonName("Next");
      }
      if (newIndex === (photoArrLength - 1)){
        setActiveStep((prevActiveStep) => prevActiveStep - photoArrLength)
      }
     
      setNbrSlide(newIndex);
    };

    
    const goToPreviousPicture = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      theme.direction = "ltr";
      setButtonName("Next");
      if (newIndex === (photoArrLength + 1)){
        setActiveStep((prevActiveStep) => prevActiveStep - photoArrLength)
      }
      setNbrSlide(newIndex);
    };


  return (   
               
    <div
    
      style={{
        marginLeft: "0%",
      }}
    >
        
       <div
        style={{
          maxWidth: 400,
          flexGrow: 1,
        }}
      >
      
        <Paper
          square
          elevation={0}
          style={{
            height: 50,
            display: "flex",
            paddingLeft: theme.spacing(2),
            backgroundColor: theme.palette.background.default,
            alignItems: "center",
          }}
        >
          <Typography className="text-left">{photoArr[newIndex].label}</Typography>
        </Paper>
        <img
          src={photoArr[newIndex].imgPath}
          style={{
            height: 255,
            width: "100%",
            maxWidth: 400,
            display: "block",
            overflow: "hidden",
          }}
          alt={photoArr[newIndex].label}
        />
        <MobileStepper
            variant="text"
            position="static"
            activeStep={newIndex}
            steps={photoArrLength}
            nextButton={
              <Button size="small" onClick={goToNextPicture} >
              {buttonName}
             {buttonIcon === "ltr" ? (
                <KeyboardArrowRight />
              
             ) : (
               <Loop />
               )}
               </Button>
            }
            backButton={
             
              <Button size="small"
              onClick={goToPreviousPicture}
              disabled={newIndex === 0}
                >
                 Prev
                <KeyboardArrowLeft />
             
              </Button>
            }
          />
        </div>
      </div>
      
    );
  
                     
   

  }

export default (ImageSlider);